<script lang="ts" setup>
import { type EpcGes, EPC_GES_CLASS_VALUES } from '@@/shared/property/epc-ges';

defineProps<{
  epcGes: EpcGes
}>();

const epcWidths = {
  A: 'w-2/5',
  B: 'w-1/2',
  C: 'w-3/5',
  D: 'w-[70%]',
  E: 'w-4/5',
  F: 'w-[90%]',
  G: 'w-full',
};
</script>

<template>
  <div class="flex flex-col gap-s">
    <p v-text="$t(`property.epc_ges.performance.title`)" />
    <div class="grid grid-cols-2">
      <div class="flex flex-col gap-2xs">
        <ul>
          <em
            class="not-italic text-xs"
            v-text="$t(`property.epc_ges.epc.emission.low`)"
          />
          <li
            v-for="epcDpeClass in EPC_GES_CLASS_VALUES"
            :key="epcDpeClass"
            class="relative grid grid-cols-[16px_1fr] h-8 mb-2xs pr-s"
            :class="{
              [`text-epc-${epcDpeClass}`]: true,
              [`after:content-[''] after:absolute after:h-0.5 after:bg-current after:top-1/2 after:right-0 after:left-5 after:transform after:-translate-y-1/2 after:translate-x-0`]: epcGes.epc?.class === epcDpeClass,
            }"
          >
            <IadTitle
              tag="b"
              class="text-black font-semibold flex justify-left items-center"
              variant="x-small"
              :text="epcDpeClass"
            />
            <p class="flex-1">
              <span
                class="flex"
                :class="{
                  [`after:content-[''] after:border-y-[1rem] after:border-l-[0.5rem] after:border-y-transparent`]: true,
                  [`${epcWidths[epcDpeClass]}`]: true,
                }"
              >
                <i class="flex-1 h-8 bg-current" />
              </span>
            </p>
          </li>
          <em
            class="not-italic text-xs block w-40"
            v-text="$t(`property.epc_ges.epc.emission.high`)"
          />
        </ul>
      </div>
      <PropertyDiagnosticInfo
        :epc-ges
        variant="epc"
      />
    </div>
    <PropertyDiagnosticAmount :epc-ges />
  </div>
</template>
